import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getActiveCompany, getAppConfigurationValue } from '../../../../redux/helpers'
import AxiosInstance from '../../../http-config'

import { EnumCommodity } from '../../..'

import { CheckValuesDatesResponse } from '../../model/checkValuesDatesResponse'
import { EditablePriceModel } from '../../model/editablePriceModel'
import { NewPriceRequest } from '../../requests/newPrice.request'

import moment from 'moment'
import { enumValueToKey } from '../../../../helpers'
import { EnumPriceType } from '../../../oData/enums/enumPriceType'
import { ArgentiaPricingTableModel } from '../priceComponents'
import {
  CreateOrUpdatePriceValueRequest,
  PricesModel,
  PricingTableModel,
  ValidatePriceModel,
  ValidatePriceRequestModel,
  ValidatePriceTypeRequestModel,
  ValidatePriceTypeResponseModel
} from './model/prices'
import { PriceValuesModel } from './model/values'

export const fetchPrices = async (
  commodity: EnumCommodity,
  priceType: EnumPriceType[]
): Promise<PricingTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const activeCompany = getActiveCompany()

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Prices?commodity=${commodity}&priceType=[${priceType.toString()}]&companyID=${
      activeCompany!.id
    }`
  ).then(response => {
    return response.data
  })
}

// This function fetches prices that are not subscribed to a priceComponent
export const fetchPricesNotSubscribed = async (
  commodityID: number,
  priceType: number
): Promise<ArgentiaPricingTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59923'
  const activeCompanyID = getActiveCompany()?.id || 0

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Prices/PricesNotSubscribed?commodity=${commodityID}&companyID=${activeCompanyID}&priceType=${priceType}`
  ).then(response => {
    if (response) {
      return response.data
    } else {
      return []
    }
  })
}

export const fetchParameterPricesWithoutPriceComponents = async (
  commodity: EnumCommodity
): Promise<PricingTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const activeCompany = getActiveCompany()

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Prices/PricesParameters?commodity=${commodity}&&companyID=${activeCompany!.id}`
  ).then(response => {
    return response.data
  })
}

// OBSOLETE -- use fetchParameterBasePriceComponents() from priceComponent.api.ts instead
export const fetchParameterPricesBaseComponents = async (
  commodity: EnumCommodity
): Promise<PricingTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const activeCompany = getActiveCompany()

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Prices/PricesParametersBaseComponents?commodity=${commodity}&&companyID=${activeCompany!.id}`
  ).then(response => {
    return response.data
  })
}

export const fetchPriceByID = async (id: number): Promise<PricesModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Prices/${id}`).then(response => {
    return response.data
  })
}

export const fetchPriceValues = async (id: number): Promise<PriceValuesModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Prices/Values/${id}`).then(response => {
    return response.data
  })
}

export const apiGetPriceCurrentValues = async (
  pricesIds: number[],
  startDate: string,
  endDate: string
): Promise<PriceValuesModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Prices/GetCurrentPriceValues?pricesIds=[${pricesIds.join(',')}]&startDate=${startDate}&endDate=${endDate}`
  ).then(response => {
    return response.data
  })
}

export const fetchSubscribedPrices = async (id: number): Promise<PricesModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Prices/SubscribedPrices/${id}`).then(
    response => {
      return response.data
    }
  )
}

export const validatePriceExpression = async (
  request: ValidatePriceRequestModel
): Promise<ValidatePriceModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Prices/Validate`, request).then(response => {
    return response.data
  })
}

export const validatePriceExpressionType = async (
  request: ValidatePriceTypeRequestModel
): Promise<ValidatePriceTypeResponseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Prices/ValidateType`, request).then(
    response => {
      return response.data
    }
  )
}

export const apiPricesPOST = async (request: NewPriceRequest): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Prices`, request).then(response => {
    return response.data
  })
}

export const apiValuePOST = async (
  priceId: number,
  request: CreateOrUpdatePriceValueRequest
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Prices/Values/${priceId}`, request).then(
    response => {
      return response.data
    }
  )
}

export const apiDeletePrice = async (priceId: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/Prices/${priceId}`).then(response => {
    return response.data
  })
}

export const apiDeletePriceValue = async (
  priceId: number,
  priceValueId: number,
  priceComponentID?: number | null
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  let query = ''
  if (priceComponentID) {
    query = `priceComponentId=${priceComponentID}`
  }

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/Prices/${priceId}/Values/${priceValueId}?${query}`
  ).then(response => {
    return response.data
  })
}

export const apiPatchPrice = async (priceId: number, request: EditablePriceModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59923'

  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Prices/${priceId}`, request).then(
    response => {
      return response.data
    }
  )
}

export const apiFetchPriceTypeCalculationTypeCompatibility = async (): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Prices/PriceTypeCalculationTypeCompatibility`
  ).then(response => {
    return response.data
  })
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => reject(new Error()), 2000)
  // })
}

export const apiFetchPriceTypeCompatibility = async (priceType: EnumPriceType): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const priceTypeLabel = enumValueToKey(EnumPriceType, priceType)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Prices/PriceTypeCompatibility?priceType=${priceTypeLabel}`
  ).then(response => {
    return response.data
  })
}

export const apiPostCheckCodeRepeated = async (
  priceCode: string,
  priceId: number
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = { condition: { action: 0 }, cdPrice: priceCode, idPrice: priceId }

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Prices/CheckCodeRepeated`, request).then(
    response => {
      return response.data
    }
  )
}

export const apiPostCheckValuesDates = async (
  startDate: Date,
  endDate: Date,
  priceId?: number,
  priceValueId?: number
): Promise<CheckValuesDatesResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = {
    condition: { action: 1 },
    idPrice: priceId,
    idPriceValue: priceValueId ?? 0,
    startDate: moment(startDate).format(),
    endDate: moment(endDate).format()
  }

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Prices/CheckValuesDates`, request).then(
    response => {
      return response.data
    }
  )
}
